import React from "react";
import { createRoot } from "react-dom/client";
import RoadmapClient from "./RoadmapClient";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Missing #root mount element.");
}

createRoot(root).render(
  <React.StrictMode>
    <RoadmapClient />
  </React.StrictMode>,
);
